
import { useState } from 'react';
import type { FormEvent } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!email) {
      setMessage('Lütfen e-posta adresinizi girin');
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch(
        'https://readdy.ai/api/form/d6aoivdbiueuoqm1skq0',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData.toString(),
        }
      );

      // Optional: try to read response body for more detailed error messages
      const responseData = await response.text();

      if (response.ok) {
        setMessage('Başarıyla abone oldunuz! Teşekkür ederiz.');
        setEmail('');
      } else {
        // If the API returns a specific error message, show it
        const errorMsg =
          responseData || 'Bir hata oluştu. Lütfen tekrar deneyin.';
        setMessage(errorMsg);
      }
    } catch (error) {
      // Provide a fallback error message while still logging the actual error
      console.error('Newsletter submission error:', error);
      setMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-10 sm:py-12 md:py-16 bg-gradient-to-r from-brand-700 to-brand-500">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
            <i className="ri-mail-line text-2xl sm:text-3xl md:text-4xl text-white"></i>
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2 sm:mb-3">
            Kampanyalardan Haberdar Olun
          </h2>
          <p className="text-brand-100 text-xs sm:text-sm mb-5 sm:mb-6 md:mb-8 px-2">
            Özel indirimler, yeni ürünler ve sağlık ipuçları için bültenimize
            abone olun
          </p>

          <form
            id="newsletter-form"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-2 sm:gap-3 max-w-xl mx-auto px-2"
            data-readdy-form
          >
            <input
              type="email"
              name="email"
              placeholder="E-posta adresiniz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-4 sm:px-6 py-3 sm:py-4 rounded-lg outline-none text-gray-700 text-sm"
              disabled={isSubmitting}
              required
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-gray-800 hover:bg-gray-900 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-medium transition-colors text-sm cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Gönderiliyor...' : 'Abone Ol'}
            </button>
          </form>

          {message && (
            <p
              className={`mt-3 sm:mt-4 text-xs sm:text-sm ${
                message.includes('Başarıyla')
                  ? 'text-white'
                  : 'text-red-200'
              }`}
            >
              {message}
            </p>
          )}

          <p className="text-brand-200 text-[10px] sm:text-xs mt-3 sm:mt-4 px-2">
            Kişisel verileriniz gizlilik politikamız kapsamında korunmaktadır
          </p>
        </div>
      </div>
    </section>
  );
}
